// Module
var code = `<i class="fa fa-check" ng-if="checkController.value === true"></i> `;
// Exports
module.exports = code;